import React from 'react';
import { Link } from 'react-router-dom';

const FAQPage = () => {
    return (
        <>
            {/* PAGE HERO */}
            <div id="faqs-page" className="page-hero-section division">
                <div className="page-hero-overlay division">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-xl-8">
                                <div className="hero-txt text-center white-color">
                                    {/* Title */}
                                    <h2 className="h2-xs">Frequently Asked Questions</h2>
                                    {/* Text */}
                                    <p className="p-xl">
                                        Find answers to common questions about Rush Studio, our translation
                                        services, and how to get the most out of our platform.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* End row */}
                    </div>
                    {/* End container */}
                </div>
                {/* End hero-overlay */}
                {/* WAVE SHAPE BOTTOM */}
                <div className="wave-shape-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 80">
                        <path
                            fill="#ffffff"
                            fillOpacity={1}
                            d="M0,32L120,42.7C240,53,480,75,720,74.7C960,75,1200,53,1320,42.7L1440,32L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
                        />
                    </svg>
                </div>
            </div>
            {/* END PAGE HERO */}

            {/* FAQs-2 */}
            <section id="faqs-2" className="wide-60 faqs-section division">
                <div className="container">
                    {/* FAQs-2 QUESTIONS */}
                    <div className="faqs-2-questions">
                        <div className="row row-cols-1 row-cols-lg-2">
                            {/* QUESTIONS HOLDER */}
                            <div className="col">
                                <div className="questions-holder pr-15">
                                    {/* QUESTION #1 */}
                                    <div className="question wow fadeInUp">
                                        {/* Question */}
                                        <h5 className="h5-md">
                                            What file formats does Rush Studio support?
                                        </h5>
                                        {/* Answer */}
                                        <p className="p-lg">
                                            Rush Studio supports a wide range of file formats including DOCX,
                                            XLSX, IDML (InDesign), JSON, XML, HTML, and plain text files.
                                            We preserve formatting and structure during translation to ensure
                                            your documents maintain their original appearance.
                                        </p>
                                    </div>
                                    {/* QUESTION #2 */}
                                    <div className="question wow fadeInUp">
                                        {/* Question */}
                                        <h5 className="h5-md">
                                            How does the translation memory work?
                                        </h5>
                                        {/* Answer */}
                                        <p className="p-lg">
                                            Translation memory stores previously translated segments and
                                            automatically suggests them when similar content appears in new
                                            projects. This ensures consistency across your translations,
                                            reduces costs, and speeds up your workflow significantly.
                                        </p>
                                    </div>
                                    {/* QUESTION #3 */}
                                    <div className="question wow fadeInUp">
                                        {/* Question */}
                                        <h5 className="h5-md">
                                            Can I collaborate with my team on Rush Studio?
                                        </h5>
                                        {/* Answer */}
                                        <ul className="simple-list">
                                            <li className="list-item">
                                                <p className="p-lg">
                                                    Yes! Rush Studio offers comprehensive team collaboration
                                                    features including role-based access control, task
                                                    assignment, and real-time updates.
                                                </p>
                                            </li>
                                            <li className="list-item">
                                                <p className="p-lg">
                                                    Team members can work simultaneously on different languages
                                                    or sections, with built-in chat and commenting features
                                                    for seamless communication.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    {/* QUESTION #4 */}
                                    <div className="question wow fadeInUp">
                                        {/* Question */}
                                        <h5 className="h5-md">
                                            Which translation engines do you integrate with?
                                        </h5>
                                        {/* Answer */}
                                        <p className="p-lg">
                                            We integrate with leading translation engines including DeepL,
                                            Google Translate, and OpenAI. You can choose your preferred
                                            engine for each project or even combine multiple engines to
                                            get the best results for your specific content.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* END QUESTIONS HOLDER */}
                            {/* QUESTIONS HOLDER */}
                            <div className="col">
                                <div className="questions-holder pl-15">
                                    {/* QUESTION #5 */}
                                    <div className="question wow fadeInUp">
                                        {/* Question */}
                                        <h5 className="h5-md">Do you offer a free trial?</h5>
                                        {/* Answer */}
                                        <p className="p-lg">
                                            Yes! We offer a free tier that includes 500MB of storage and
                                            support for up to 2 target languages per project. This allows
                                            you to explore Rush Studio's features and see how it fits your
                                            translation workflow before upgrading.
                                        </p>
                                    </div>
                                    {/* QUESTION #6 */}
                                    <div className="question wow fadeInUp">
                                        {/* Question */}
                                        <h5 className="h5-md">How does Rush Studio handle data security?</h5>
                                        {/* Answer */}
                                        <p className="p-lg">
                                            We take security seriously. All data is encrypted in transit
                                            and at rest. We use industry-standard security practices and
                                            comply with data protection regulations.
                                        </p>
                                        {/* Answer */}
                                        <p className="p-lg">
                                            Your translation projects and files are stored securely, and
                                            you maintain full control over who has access to your content
                                            through our role-based permission system.
                                        </p>
                                    </div>
                                    {/* QUESTION #7 */}
                                    <div className="question wow fadeInUp">
                                        {/* Question */}
                                        <h5 className="h5-md">Can I integrate Rush Studio with cloud storage?</h5>
                                        {/* Answer */}
                                        <ul className="simple-list">
                                            <li className="list-item">
                                                <p className="p-lg">
                                                    Absolutely! Rush Studio integrates seamlessly with Google
                                                    Drive, Dropbox, and OneDrive.
                                                </p>
                                            </li>
                                            <li className="list-item">
                                                <p className="p-lg">
                                                    You can import files directly from your cloud storage and
                                                    export translated files back to your preferred platform,
                                                    keeping everything synchronized.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    {/* QUESTION #8 */}
                                    <div className="question wow fadeInUp">
                                        {/* Question */}
                                        <h5 className="h5-md">What languages are supported?</h5>
                                        {/* Answer */}
                                        <p className="p-lg">
                                            Rush Studio supports over 100 languages, covering all major
                                            world languages and many regional dialects. The specific
                                            languages available may vary depending on which translation
                                            engine you choose to use for your project.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* END QUESTIONS HOLDER */}
                        </div>
                        {/* End row */}
                    </div>
                    {/* END FAQs-2 QUESTIONS */}
                    {/* MORE QUESTIONS BUTTON */}
                    <div className="row">
                        <div className="col">
                            <div className="more-questions">
                                <h5 className="h5-sm">
                                    Have more questions?{' '}
                                    <Link to="/contact">
                                        Ask your question here
                                    </Link>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End container */}
            </section>
            {/* END FAQs-2 */}

            {/* CALL TO ACTION-7 */}
            <div id="cta-7" className="cta-section division">
                <div className="container">
                    <div className="cta-7-wrapper bg-snow">
                        <div className="row d-flex align-items-center">
                            {/* TEXT */}
                            <div className="col-lg-9">
                                <div className="cta-7-txt">
                                    <p className="p-xl">
                                        Still have a question? Don't worry, our customer care team
                                        is ready to help you with any questions or problems
                                    </p>
                                </div>
                            </div>
                            {/* BUTTON */}
                            <div className="col-lg-3 text-end">
                                <div className="cta-7-btn">
                                    <Link to="/contact" className="btn btn-skyblue tra-grey-hover">
                                        Contact Us
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* End row */}
                    </div>
                    {/* End cta-7-wrapper */}
                </div>
                {/* End container */}
            </div>
            {/* END CALL TO ACTION-7 */}
        </>
    );
};

export default FAQPage;
